import { Dispatch } from 'redux';
import URLConstants from '../constants/url.constants';
import * as services from '../services/services';
import sensorDataType from '../types/sensorData.type';

export const getSensorData = (data: any) => {
	return (dispatch: Dispatch) => {
		dispatch(getSensorDataStart());
		let url = URLConstants.GetSensorDataById + '/' + data.Model +'/' + data.ICCID  + '?pageNo=' + data.CurrentPage + '&pageSize=' +  data.PageSize+ '&orderBy=' + data.OrderBy;
		services.get(url)
			.then(response => {
				dispatch(getSensorDataSuccess(response.data));
			})
			.catch(err => {
				dispatch(getSensorDataError(err));
			});
	};
};

const getSensorDataStart = () => {
	return {
		type: sensorDataType.GET_SENSOR_DATA_START
	};
};

const getSensorDataSuccess = (data: any) => {
	return {
		type: sensorDataType.GET_SENSOR_DATA_SUCCESS,
		payload: data
	};
};

const getSensorDataError = (data: any) => {
	return {
		type: sensorDataType.GET_SENSOR_DATA_ERROR,
		payload: data
	};
};